import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { LinkscompartidosService } from "../components/simple-page/services/linkscompartidos.service";
import { BaseResponse } from "../shared/models/base-api-response.interface";
import Swal from "sweetalert2";
import {
  Estudio,
  GrupoEstudios,
} from "../components/simple-page/models/estudios.interface";
import { HcliniaService } from "../components/simple-page/services/hclinia.service";
import { PacienteService } from "../components/simple-page/services/paciente.service";

@Component({
  selector: "app-estudios",
  templateUrl: "./estudios.component.html",
  styleUrls: ["./estudios.component.scss"],
})
export class EstudiosComponent implements OnInit {
  urlToken: string;
  message: boolean = false;
  linkExpired: string;
  grupos: any[] = [];
  paciente: string;
  public collapseIndex: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private _linkCompartidos: LinkscompartidosService,
    private _hclinicaService: HcliniaService,
    private _pacienteService: PacienteService,
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const token = params.get("token");
      this.urlToken = token;
    });
    this.obtenerMisEstudios();
  }

  toggleCollapse(index: number): void {
    if (this.collapseIndex === index) {
      this.collapseIndex = null;
    } else {
      this.collapseIndex = index;
    }
  }

  obtenerMisEstudios() {
    this._linkCompartidos.LinkCompartidoIsExpired(this.urlToken).subscribe({
      next: (data: BaseResponse) => {
        if (data.isSuccess) {
          this._linkCompartidos.LinkCompartidoEncrypt(this.urlToken).subscribe({
            next: (data: BaseResponse) => {
              if (data.isSuccess) {
                this.grupos = this.agruparEstudios(data.data);
                this._pacienteService.PacienteById(this.grupos[0].hc).subscribe((data)=>{
                  if (data.isSuccess) {
                    this.paciente = data.data.nombre;
                  }
                  else {
                    this.paciente = 'Estudios'
                  }
                })
                this.message = this.grupos.length > 0;
              }
            },
            error: (error) => {
              Swal.fire(error);
            },
          });
        } else {
          this.message = false;
          this.linkExpired = data.message;
        }
      },
      error: (error) => {
        Swal.fire(error);
      },
    });
  }

  private agruparEstudios(estudios: Estudio[]): GrupoEstudios[] {
    const grupos: { [key: string]: GrupoEstudios } = {};

    estudios.forEach((estudio) => {
      const clave = `${estudio.fecha}-${estudio.nombre}`;
      if (!grupos[clave]) {
        grupos[clave] = {
          hc: estudio.hc,
          fecha: estudio.fecha,
          nombre: estudio.nombre,
          descripcion: estudio.descripcion,
          estudios: [],
        };
      }
      grupos[clave].estudios.push(estudio);
    });

    return Object.values(grupos);
  }

  getUrlDescarga(rutayNombre: string): string {
    return this._hclinicaService.getUrlDescarga(rutayNombre);
  }
}
